<div class="ltms-tools-container" [id]="elementId">
    <div class="tools-item" *ngIf="enableTrendTypeSelector">
        <app-ltms-dropdown  [config]="dropdown" [elementid]="dropdown.elementid"
        (onChange)="onFilterChange($event)"></app-ltms-dropdown>
    </div>
    <div class="view-change-button tools-item" [class.rotate]="viewSelector.type == 'table'" *ngIf="viewSelector.enable" #viewTypeSelector >
        <button class="view-selection-button" (click)="toggleViewSelector($event)">
            <img title="Absolute Bar Chart" class="chart-icon" *ngIf="viewType == 'absolute'" src="assets/images/bar-chart-percent.svg" />
            <img title="Percent Bar Chart" class="chart-icon" *ngIf="viewType == 'percent'" src="assets/images/bar_chart.svg" />
            <img class="arrow-icon" src="assets/images/menu-down-dark.svg" />
        </button>
        <ul class="view-selector" [class.show]="isViewSelectorOpen">
            <li title="Absolute Bar Chart" (click)="onViewTypeChange('absolute')">
                <img src="assets/images/bar_chart.svg" />
            </li>
            <li title="Percent Bar Chart" (click)="onViewTypeChange('percent')">
                <img src="assets/images/bar-chart-percent.svg" />
            </li>
        </ul>
    </div>
    <div class="download-button tools-item" *ngIf="download.enable" (click)="config.download?.data?.rows?.length ? downloadReport($event) : null ">
        <img  [ngStyle]="{ 'opacity': config.download?.data?.rows?.length ? 1 : 0.5 }" src="assets/images/download.svg"/>
    </div>
    <div class="fullscreen-button tools-item" *ngIf="fullscreen.enable" (click)="changeFullscreenMod()" (click)="changeFullscreenForEnagagement()">
        <img src="assets/images/fullscreen.svg" *ngIf="!isFullScreenEnabled && !isFullscreenengagement" />
        <img class="exitFullScreen" src="assets/images/fullscreen-exit.svg" *ngIf="isFullScreenEnabled || isFullscreenengagement" />
    </div>
</div> 